(ns frontend.view.components.form.components.form-tesi-financials
  (:require
   [frontend.view.components.tesi-financials :as tesi-financials]
   [reagent.core :as r]
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [common.currencies :as currencies]
   [ui.components.button.view :as button]))

(defn view
  [{:keys [label size value wrapper field
           mandatory? read-only?
           control-id edit? set-edit! on-change! on-submit! on-cancel!]}]
  (let [edit-tooltip (r/as-element [rbs/Tooltip
                                    {:class "in"
                                     :id    "edit-tooltip"}
                                    [:i.fal.fa-edit] " Click to Edit"])]
    [rbs/Form
     {:on-submit on-submit!}
     (when-not read-only?
       [:div.financials-toolbar.form-group
        [:div.control-label
         (loc/tr :company/tesi-financials)
         (when mandatory?
           [:span.mandatory " *"])]
        [:div.align-right
         (if-not @edit?
            [button/square-secondary-hollow
            {:tooltip edit-tooltip
             :on-click   (fn [e]
                           (when (fn? set-edit!)
                             (set-edit! true)))}
            [:i.fal.fa-edit]]
           

           [button/secondary-hollow
            {:type       "submit"}
            (loc/tr :save)])]])
     [rbs/FormGroup
      {:style {:overflow "auto"}}
      [tesi-financials/financials-view
       {:value      value
        :currencies currencies/currencies
        :edit?      @edit?
        :on-change  on-change!}]]]))
